import React from 'react';
import Dropdown from 'relements/build/esm/input/dropdown';
import Checkbox from 'relements/build/esm/input/checkbox';
import { isNewPipeline } from '@src/actions/_utils';

const BOT_SETTINGS = {
  title: 'Bot Settings',
  className: 'extra-long-inputs',
  inputs: [
    {
      label: 'Enable Human Assistance',
      key: 'enableHumanAssistance',
      className: 'inline-checkbox',
      component: Checkbox.Item,
      formSideEffects: (value, form, meta) => ({
        // form is unused now, but can be used in future to decide object values
        liveAgentChatTool: value ? meta.allLacts[0] : '',
      }),
    },
    {
      label: 'Enable SmallTalk',
      key: 'enableSmallTalk',
      className: 'inline-checkbox',
      component: Checkbox.Item,
    },
    {
      label: 'Enable user file deletion',
      key: 'requestsPii',
      className: 'inline-checkbox',
      component: Checkbox.Item,
    },
    {
      label: 'FORCE_BREAK',
      key: 'forceBreak1',
      component: () => <div style={{ minWidth: '100%' }} />,
    },
    {
      label: 'Live Agent Chat Tool',
      key: 'liveAgentChatTool',
      component: Dropdown,
      props: (value, onChange, form, meta) => ({
        prefixClassName: `${form.enableHumanAssistance ? '' : 'hidden'}`,
        options: meta.allLacts,
        optionKey: 'value',
      }),
    },
    {
      label: 'FORCE_BREAK',
      key: 'forceBreak2',
      component: () => <div style={{ minWidth: '100%' }} />,
    },
    {
      label: 'Active Bots',
      key: 'activeBots',
      component: Dropdown,
      props: (value, onChange, form, meta) => {
        const isSuperman = isNewPipeline({
          pipeline_version: form.pipelineVersion,
        });
        const isMultiple = !isSuperman;
        const nValue = isMultiple ? value : value[0];
        const nOnChange = isMultiple ? onChange : val => onChange([val]);
        return {
          value: nValue,
          onChange: nOnChange,
          options: meta.allBots,
          optionKey: 'value',
          searchKeys: ['value'],
          withSearch: true,
          withMultiple: isMultiple,
        };
      },
    },
    {
      label: 'Default Bot',
      key: 'defaultBot',
      component: Dropdown,
      props: (value, onChange, form, meta) => ({
        options: meta.allBots.filter(bot =>
          form.activeBots.includes(bot.value)
        ),
        optionKey: 'value',
        allowClear: true,
        searchKeys: ['value'],
        withSearch: true,
      }),
    },
    {
      label: 'Fallback Bot',
      key: 'fallbackBot',
      component: Dropdown,
      props: (value, onChange, form, meta) => ({
        options: meta.allBots.filter(bot =>
          form.activeBots.includes(bot.value)
        ),
        optionKey: 'value',
        searchKeys: ['value'],
        withSearch: true,
      }),
    },
  ],
};

export default BOT_SETTINGS;
